var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2032",
    "data-name": "Rectangle 2032",
    width: 22,
    height: 22.002,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4058",
    "data-name": "Group 4058",
    transform: "translate(-548 -700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3878",
    "data-name": "Group 3878",
    transform: "translate(550 701.999)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8721",
    "data-name": "Path 8721",
    d: "M21.846,27.7a10.843,10.843,0,0,1-.888,1.691H2.427A10.843,10.843,0,0,1,1.539,27.7Z",
    transform: "translate(-0.693 -12.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8722",
    "data-name": "Path 8722",
    d: "M21.946,24.618a10.644,10.644,0,0,1-.55,1.693H1.089a10.816,10.816,0,0,1-.551-1.693Z",
    transform: "translate(-0.242 -11.078)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8723",
    "data-name": "Path 8723",
    d: "M21.994,21.539a10.944,10.944,0,0,1-.265,1.693H.322a11.01,11.01,0,0,1-.264-1.693Z",
    transform: "translate(-0.026 -9.693)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8724",
    "data-name": "Path 8724",
    d: "M21.685,30.77a10.838,10.838,0,0,1-1.335,1.693H4.49A10.966,10.966,0,0,1,3.155,30.77Z",
    transform: "translate(-1.42 -13.847)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8725",
    "data-name": "Path 8725",
    d: "M21.064,36.926a10.977,10.977,0,0,1-11.713,0Z",
    transform: "translate(-4.208 -16.617)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8726",
    "data-name": "Path 8726",
    d: "M21.442,33.848a10.959,10.959,0,0,1-2.073,1.693H7.656a11.121,11.121,0,0,1-2.074-1.693Z",
    transform: "translate(-2.512 -15.232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8727",
    "data-name": "Path 8727",
    d: "M21.442,4.772H5.582A11.065,11.065,0,0,1,7.658,3.079H19.366a11.047,11.047,0,0,1,2.076,1.693",
    transform: "translate(-2.512 -1.386)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8728",
    "data-name": "Path 8728",
    d: "M21.064,1.693H9.356a10.746,10.746,0,0,1,1.086-.6c.034-.015.069-.032.106-.049.125-.059.254-.116.385-.173.057-.025.116-.047.173-.069a10.914,10.914,0,0,1,4.1-.8h0a10.927,10.927,0,0,1,5.854,1.693",
    transform: "translate(-4.21 0)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8729",
    "data-name": "Path 8729",
    d: "M21.685,7.847H3.155c.1-.151.2-.3.3-.447a.318.318,0,0,1,.027-.037,11.319,11.319,0,0,1,1-1.207H20.35a10.951,10.951,0,0,1,1.335,1.691",
    transform: "translate(-1.42 -2.77)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8730",
    "data-name": "Path 8730",
    d: "M21.946,14H.538a10.987,10.987,0,0,1,.551-1.693H21.4A10.81,10.81,0,0,1,21.946,14",
    transform: "translate(-0.242 -5.539)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8731",
    "data-name": "Path 8731",
    d: "M21.846,10.924H1.539c.045-.108.091-.217.144-.326.118-.26.246-.516.384-.763.114-.2.234-.407.36-.6H20.958a10.965,10.965,0,0,1,.888,1.693",
    transform: "translate(-0.693 -4.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8732",
    "data-name": "Path 8732",
    d: "M21.994,17.08H.058c0-.071.013-.141.02-.21.017-.207.044-.413.074-.617.045-.292.1-.582.17-.866H21.73a10.9,10.9,0,0,1,.265,1.693",
    transform: "translate(-0.026 -6.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8733",
    "data-name": "Path 8733",
    d: "M22,19.309c0,.287-.01.568-.032.846H.032C.01,19.877,0,19.6,0,19.309s.01-.565.032-.844H21.968c.022.279.032.56.032.844",
    transform: "translate(0 -8.31)",
    fill: "#b12233"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8734",
    "data-name": "Path 8734",
    d: "M11,0V11.846H.032C.009,11.568,0,11.287,0,11s.009-.565.032-.844c0-.072.012-.14.02-.21.016-.207.044-.412.074-.617.044-.291.1-.582.17-.866A11.049,11.049,0,0,1,.847,6.77c.045-.109.091-.217.143-.326.118-.259.247-.515.385-.762.113-.205.234-.408.36-.605.1-.15.2-.3.3-.447a.313.313,0,0,1,.027-.037,11.151,11.151,0,0,1,1-1.207A11.032,11.032,0,0,1,5.146,1.693a10.737,10.737,0,0,1,1.086-.6c.035-.015.069-.032.106-.049.126-.059.255-.116.385-.173C6.779.842,6.839.82,6.9.8A10.914,10.914,0,0,1,11,0",
    transform: "translate(0 0)",
    fill: "#3c3b6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8735",
    "data-name": "Path 8735",
    d: "M16.93,1.028l.156.474h.5l-.4.3.155.476-.407-.3-.4.3.156-.476-.4-.3h.5Z",
    transform: "translate(-7.324 -0.463)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8736",
    "data-name": "Path 8736",
    d: "M12.289,2.345l.037.118-.16-.118-.245-.178-.244.178-.161.118.037-.118.116-.358-.338-.246c.035-.015.069-.032.106-.049h.328l.057-.173c.057-.025.116-.047.173-.069l.081.242h.5l-.4.3Z",
    transform: "translate(-5.099 -0.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8737",
    "data-name": "Path 8737",
    d: "M16.93,5.331l.156.476h.5l-.4.294.155.476-.407-.294-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-7.324 -2.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8738",
    "data-name": "Path 8738",
    d: "M11.866,5.331l.156.476h.5l-.4.294.156.476-.4-.294-.4.294.156-.476-.408-.294h.5Z",
    transform: "translate(-5.044 -2.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8739",
    "data-name": "Path 8739",
    d: "M6.8,5.331l.153.476h.5L7.053,6.1l.156.476-.4-.294L6.4,6.577,6.552,6.1l-.4-.294h.5Z",
    transform: "translate(-2.766 -2.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8740",
    "data-name": "Path 8740",
    d: "M16.93,9.639l.156.476h.5l-.4.294.155.476-.407-.294-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-7.324 -4.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8741",
    "data-name": "Path 8741",
    d: "M11.866,9.639l.156.476h.5l-.4.294.156.476-.4-.294-.4.294.156-.476-.408-.294h.5Z",
    transform: "translate(-5.044 -4.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8742",
    "data-name": "Path 8742",
    d: "M6.8,9.639l.153.476h.5l-.405.294.156.476-.4-.294-.407.294.155-.476-.4-.294h.5Z",
    transform: "translate(-2.766 -4.338)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8743",
    "data-name": "Path 8743",
    d: "M2.313,10.72l.153.476L2.061,10.9l-.261.19c.118-.26.247-.516.385-.763l.032.1h.5Z",
    transform: "translate(-0.81 -4.649)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8744",
    "data-name": "Path 8744",
    d: "M16.93,13.942l.156.476h.5l-.4.3.155.474-.407-.294-.4.294.156-.474-.4-.3h.5Z",
    transform: "translate(-7.324 -6.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8745",
    "data-name": "Path 8745",
    d: "M11.866,13.942l.156.476h.5l-.4.3.156.474-.4-.294-.4.294.156-.474-.408-.3h.5Z",
    transform: "translate(-5.044 -6.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8746",
    "data-name": "Path 8746",
    d: "M6.8,13.942l.153.476h.5l-.405.3.156.474-.4-.294-.407.294.155-.474-.4-.3h.5Z",
    transform: "translate(-2.766 -6.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8747",
    "data-name": "Path 8747",
    d: "M1.74,13.942l.156.476h.5l-.408.3.156.474-.4-.294-.4.294.156-.474-.4-.3h.5Z",
    transform: "translate(-0.489 -6.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8748",
    "data-name": "Path 8748",
    d: "M16.93,18.25l.156.476h.5l-.4.294.155.476L16.93,19.2l-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-7.324 -8.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8749",
    "data-name": "Path 8749",
    d: "M11.866,18.25l.156.476h.5l-.4.294.156.476-.4-.294-.4.294.156-.476-.408-.294h.5Z",
    transform: "translate(-5.044 -8.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8750",
    "data-name": "Path 8750",
    d: "M6.8,18.25l.153.476h.5l-.405.294.156.476L6.8,19.2,6.4,19.5l.155-.476-.4-.294h.5Z",
    transform: "translate(-2.766 -8.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8751",
    "data-name": "Path 8751",
    d: "M1.74,18.25l.156.476h.5l-.408.294.156.476-.4-.294-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-0.489 -8.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8752",
    "data-name": "Path 8752",
    d: "M14.4,16.1l.156.476h.5l-.4.294.153.476-.4-.294-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-6.185 -7.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8753",
    "data-name": "Path 8753",
    d: "M9.335,16.1l.153.476h.5l-.4.294.155.476-.4-.294-.4.294.153-.476-.4-.294h.5Z",
    transform: "translate(-3.905 -7.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8754",
    "data-name": "Path 8754",
    d: "M4.271,16.1l.155.476h.5l-.4.294.153.476-.4-.294-.4.294.155-.476-.4-.294h.5Z",
    transform: "translate(-1.627 -7.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8755",
    "data-name": "Path 8755",
    d: "M.151,17.256l.156.476-.212-.153c.017-.207.045-.413.074-.617H.555Z",
    transform: "translate(-0.042 -7.633)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8756",
    "data-name": "Path 8756",
    d: "M14.4,11.793l.156.476h.5l-.4.294.153.476-.4-.3-.4.3.156-.476-.4-.294h.5Z",
    transform: "translate(-6.185 -5.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8757",
    "data-name": "Path 8757",
    d: "M9.335,11.793l.153.476h.5l-.4.294.155.476-.4-.3-.4.3.153-.476-.4-.294h.5Z",
    transform: "translate(-3.905 -5.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8758",
    "data-name": "Path 8758",
    d: "M4.271,11.793l.155.476h.5l-.4.294.153.476-.4-.3-.4.3.155-.476-.4-.294h.5Z",
    transform: "translate(-1.627 -5.307)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8759",
    "data-name": "Path 8759",
    d: "M14.4,7.485l.156.476h.5l-.4.294.153.476-.4-.294-.4.294.156-.476-.4-.294h.5Z",
    transform: "translate(-6.185 -3.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8760",
    "data-name": "Path 8760",
    d: "M9.335,7.485l.153.476h.5l-.4.294.155.476-.4-.294-.4.294.153-.476-.4-.294h.5Z",
    transform: "translate(-3.905 -3.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8761",
    "data-name": "Path 8761",
    d: "M4.625,8.444l.094.287-.395-.287-.012-.007L4.3,8.444l-.393.287L4,8.444l.062-.19L3.707,8a.318.318,0,0,1,.027-.037h.422l.156-.476.155.476h.5l-.4.294Z",
    transform: "translate(-1.668 -3.368)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8762",
    "data-name": "Path 8762",
    d: "M14.4,3.177l.156.476h.5l-.4.3.153.474-.4-.294-.4.294.156-.474-.4-.3h.5Z",
    transform: "translate(-6.185 -1.43)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8763",
    "data-name": "Path 8763",
    d: "M9.335,3.177l.153.476h.5l-.4.3.155.474-.4-.294-.4.294.153-.474-.4-.3h.5Z",
    transform: "translate(-3.905 -1.43)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.2a0554fa9e8c944e2f8802442ca2f8a7.svg";
export { ForwardRef as ReactComponent };